import { render, staticRenderFns } from "./ModalKonserPenjualan.vue?vue&type=template&id=6870cbfe&"
import script from "./ModalKonserPenjualan.vue?vue&type=script&lang=js&"
export * from "./ModalKonserPenjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports